import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=e809c52c&scoped=true&lang=pug&"
import script from "./NoticeList.vue?vue&type=script&lang=ts&"
export * from "./NoticeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e809c52c",
  null
  
)

export default component.exports